import { DecodedToken } from "interfaces/Models/";
import { jwtDecode } from "jwt-decode";

export const deleteTokensFromStorage = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

export const getRefreshTokenFromStorage = () => {
  return localStorage.getItem("refreshToken");
};

export const getTokenFromStorage = () => {
  return localStorage.getItem("accessToken");
};

export const setTokenInStorage = (token: string) => {
  localStorage.setItem("accessToken", token);
};

export const setRefreshTokenInStorage = (refreshToken: string) => {
  localStorage.setItem("refreshToken", refreshToken);
};

export const getUserRole = () => {
  return getDecodedToken()?.role;
};

export const getUserId = () => {
  return getDecodedToken()?.sub;
};

export const getDecodedToken = () => {
  const token = getTokenFromStorage();
  if (token) {
    let decodedToken: DecodedToken = jwtDecode(token);
    return decodedToken;
  }
};
